<template>
  <div>
    <div
      class="examples__block__map__tooltip"
      :style="tooltipStyle"
    >
      {{ pointedLocation }}
    </div>
    <svg-map :map="Thailand"
             :location-class="getLocationClass"
             @mouseover="pointLocation"
             @mouseout="unpointLocation"
             @mousemove="moveOnLocation"/>
  </div>
</template>
<script>
import { SvgMap } from 'vue-svg-map';
import Thailand from '@svg-maps/thailand'

export default {
  name: 'Covid19th',
  components: {
    SvgMap
  },
  data() {
    return {
      Thailand,
      pointedLocation: 'heyhey!',
      tooltipStyle: 'heyhey!'
    };
  },
  methods: {
    pointLocation(event) {
      this.pointedLocation = this.getLocationName(event.target)
    },
    unpointLocation() {
      this.pointedLocation = null
      this.tooltipStyle = { display: 'none' }
    },
    moveOnLocation(event) {
      this.tooltipStyle = {
        display: 'block',
        top: `${event.clientY + 10}px`,
        left: `${event.clientX - 100}px`,
      }
    },
    getLocationClass() {
      // Generate heat map
      return 'blue'
    },
    getLocationName(node) {
      return node && node.attributes.name.value
    }
  }
};
</script>
<style>
  .blue {
    fill: blue;
  }
</style>
